module.exports = __webpack_public_path__ + "img/jumbopack-inactive.a559abe0.svg";